// src/sectors/pilates/dashboard/hooks/useDashboardOverview.js
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/dashboardApi';

function cleanParams(obj) {
  const out = {};
  Object.keys(obj || {}).forEach((k) => {
    const v = obj[k];
    if (v === undefined || v === null || v === '') return;
    out[k] = v;
  });
  return out;
}

export function useDashboardOverview({
  trainerScope = 'ME', // ME | ALL | TRAINER
  trainerId = null, // TRAINER ise dolu
  sessionsPeriod = 'TODAY', // TODAY | WEEK | MONTH
  months = 6,
  day = null, // "2026-01-22" veya null
} = {}) {
  const params = useMemo(
    () =>
      cleanParams({
        trainerScope,
        trainerId,
        sessionsPeriod,
        months,
        day,
      }),
    [trainerScope, trainerId, sessionsPeriod, months, day]
  );

  return useQuery({
    queryKey: ['pilatesDashboardOverview', params],
    queryFn: () => dashboardApi.overview(params),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
